import http from "./http";

export const fetchInvestmentData = () => http.get("/investments");
export const getUserInvestments = (id) => http.get(`/investments/users/${id}`)
export const fetchInterestType = () => http.get("/investments/interest")
export const fetchRiskCategory = () => http.get("/risk")
export const fetchFee = () => http.get("/config")
export const executeFeeConfig = (credentials) => {
  return http.post("/config/fees-settings", credentials) 
}

export const executeUpdateConfig = (id, payload) => {
  return http.patch(`/config/${id}/update`, payload) 
}
export const executeRisk = (credentials) => {
  return http.post("/risk/add", credentials) 
}

export const updateRisk = (id, payload) => {
  return http.put(`/risk/update/${id}`, payload) 
}

export const addInterest = (credentials) => {
    return http.post("/investments/interest/add", credentials)
}

export const updateInterest = (id, payload) => {
  return http.put(`investments/interest/update/${id}`, payload) 
}